<template>
  <b-field
    :label="label"
    :type="(hasError() ? 'is-danger': '')"
    :message="errorMessage()"
  >
    <tag
      :value="formattedValue"
      :data="data"
      :icon="icon"
      :placeholder="placeholder"
      :field="field"
      :maxtags="maxtags"
      :maxlength="maxlength"
      :allow-new="allowNew"
      :open-on-focus="openOnFocus"
      :keep-first="keepFirst"
      @input="inputListener($event)"
      @typing="onTyping"
    />
  </b-field>
</template>

<script>
import InputBase from "./InputBase";
import Tag from "../components/Tag";

export default {
  components: {
    Tag
  },
  extends: InputBase,
  props: {
    data: {
      required: true,
      type: Array
    },
    value: {
      required: true
    },
    field: {
      default: undefined,
      type: String
    },
    icon: {
      default: "label",
      type: String
    },
    maxtags: {
      type: Number,
      default: undefined
    },
    maxlength: {
      type: Number,
      default: undefined
    },
    allowNew: {
      type: Boolean,
      default: false
    },
    openOnFocus: {
      type: Boolean,
      default: false
    },
    keepFirst: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    formattedValue () {
      return _.isArray(this.value) ? this.value : [];
    }
  },
  methods: {
    onTyping (query) {
      this.$emit("typing", query);
    }
  }
};
</script>
